/* global app */

'use strict';

app.directive("or", function () {
    return {
        require: "ngModel",
        scope: {
            otherModelValue: "=or"
        },
        link: function(scope, element, attributes, ngModel) {
            ngModel.$validators.or = function (modelValue) {
                debugger
                return modelValue || scope.otherModelValue;
            };

            scope.$watch("otherModelValue", function() {
                ngModel.$validate();
            });
        }
    };
});
